import { FC } from 'react';
import { Col, Row } from 'react-bootstrap';
import styled from 'styled-components';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import {
  CheckboxSkeleton,
  TextareaSkeleton,
  ButtonSkeleton
} from '../../../common/components/Skeleton/FormSkeleton';
import { Colors } from '../../../assets';
import { Spacing } from '../../../assets/GlobalStyle/Variables';

export const LabMaterialsFormSkeleton: FC = () => {
  return (
    <StyledForm>
      {/*<Row>
        <Col xl={3} lg={12} md={12}>
          <Skeleton width={200} height={20} />
        </Col>
        <LeftPartCol xl={5} lg={12} md={12}>
          {[...Array(5)].map((_, idx) => (
            <MaterialRow key={idx}>
              <CheckboxSkeleton />
              <ButtonSkeleton />
            </MaterialRow>
          ))}
        </LeftPartCol>
        <RightPartCol xl={3} lg={12} md={12} className="right-part">
          {[...Array(6)].map((_, idx) => (
            <MaterialRow key={idx}>
              <CheckboxSkeleton />
            </MaterialRow>
          ))}
        </RightPartCol>
      </Row>*/}
      <Row>
        <Col xl={10} lg={12} md={12}>
          {[...Array(2)].map((_, idx) => (
            <MaterialTextareaRow key={idx}>
              <CheckboxSkeleton />
              <TextareaSkeleton rows={2} />
            </MaterialTextareaRow>
          ))}
        </Col>
      </Row>
      <SectionDivider />
    </StyledForm>
  );
};

const StyledForm = styled.form`
  padding-top: 1.5rem;
  padding-bottom: 100px;
  padding-left: 1rem;
`;

const MaterialRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 16px;
  align-items: center;
  margin-bottom: 8px;
`;

const MaterialTextareaRow = styled.div`
  display: grid;
  grid-template-columns: .25fr 1fr;
  gap: 32px;
  align-items: baseline;
  margin: 6px 0 12px 0;
`;

const LeftPartCol = styled(Col)`
  padding-left: 1rem;
  padding-right: 5rem;

  @media (max-width: 700px) {
    padding-right: 1rem;
  }
`;

const RightPartCol = styled(Col)`
 
`;

const SectionDivider = styled.hr`
  border: none;
  border-top: 1px solid ${Colors.lightGrey};
  margin: ${Spacing(4)} 0;
`;
